import { logger } from 'features/logger/logger';
import type { PaletteMode } from '@mui/material';

export const colorModeStorageKey = 'color-mode';

export type ColorModeStorageValue = PaletteMode;

export function readJsonFromLocalStorage<T>(key: string, fallback: T): T {
  if (typeof window === 'undefined') {
    return fallback;
  }
  const raw = window.localStorage.getItem(key);
  if (!raw) {
    return fallback;
  }
  try {
    return JSON.parse(raw) as T;
  } catch (error) {
    logger.warn(
      `Failed to parse localStorage[${key}] as JSON`,
      undefined,
      error as Error
    );
    return fallback;
  }
}
